import Constants from '@/Constants';
import { Feedback, UserRequest } from '@/models/User';
import http from '@/services/HttpService';
import { call, put } from 'redux-saga/effects';
import { PayloadAction } from 'typesafe-actions';
import _ from 'underscore';
import { getUsersFailure, getUsersSuccess, postFeedbackFailure, postFeedbackSuccess } from './action';
import { UserTypes } from './types';

export function* getUsers(action: PayloadAction<UserTypes.GET_USERS_REQUEST, UserRequest>) {
    try {
        const { applicationId, orgId, onlyActive, offset, limit } = action.payload;

        let requestUri = `${Constants.PEOPLE_URI}?applicationId=${applicationId}&orgId=${orgId}&onlyActive=${onlyActive}`;

        if (_.isNumber(offset)) {
            requestUri += `&offset=${offset}`;
        }

        if (_.isNumber(limit)) {
            requestUri += `&limit=${limit}`;
        }

        const { data, headers } = yield call(http.get, requestUri);

        yield put(getUsersSuccess(data, parseInt(headers.total)));
    } catch (err) {
        yield put(getUsersFailure(err));
    }
}

export function* postFeedback(action: PayloadAction<UserTypes.POST_FEEDBACK_SUCCESS, Feedback>) {
    try {
        yield call(http.post, `${Constants.FEEDBACK_URI}`, action.payload);
        yield put(postFeedbackSuccess());
    } catch (err) {
        yield put(postFeedbackFailure(err));
    }
}
